<script>
export default {
  name: 'ProductCard',
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
    salePrice: {
      type: String,
      default: '',
    },
    priceHtml: {
      type: String,
      default: '',
    },
    salePriceHtml: {
      type: String,
      default: '',
    },
    priceLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDiscountedPrice() {
      return this.price && this.salePrice;
    },
    priceDataTestId() {
      return {
        host: 'g__price',
        originalPrice: {
          wrapper: 'g__price__original-price',
          fromText: 'g__price__original-price__from-text',
          value: 'g__price__original-price__value',
          savingsText: 'g__price__original-price__saving-text',
        },
        discountedPrice: {
          wrapper: 'g__price__discounted-price',
        },
        detailsText: 'g__price__details-text',
        andUpText: 'g__price__and-up-text',
      };
    },
  },
};
</script>

<template>
  <div class="app__product__card">
    <a
      class="app__product__card__inner"
      :href="link"
    >
      <div
        class="app__product__card__image__con"
      >
        <img
          :src="imageSrc"
          alt=""
          class="app__product__card__image"
        >
      </div>
      <div class="app__product__card__container">
        <g-heading
          class="app__product__card__title"
          text-align="left"
          size="5"
        >
          <h3 v-html="title" />
        </g-heading>
        <g-loader
          v-if="priceLoading"
          type="default"
          class="app__product__card__loader"
        />
        <g-price
          v-if="isDiscountedPrice"
          :dataTestId.prop="priceDataTestId"
          :original-price="price"
          :discounted-price="salePrice"
          :blue-discount-font="true"
          class="app__product__card__price"
        />
        <div
          v-else-if="price"
          class="app__product__card__price"
        >{{ price }}</div>

        <div
          v-if="priceHtml"
          class="app__product__card__price__wrapper"
        >
          <div
            v-if="priceHtml"
            :class="{
              app__product__card__price: true,
              app__product__card__price__crossed: !!salePriceHtml,
            }"
            v-html="priceHtml"
          />
          <div
            v-if="salePriceHtml"
            class="app__product__card__price app__product__card__price__sale"
            v-html="salePriceHtml"
          />
        </div>
      </div>
    </a>
  </div>
</template>

<style lang="scss">
.app__product__card {
  width: 100%;
  display: flex;
  align-items: stretch;
  margin-bottom: 1rem;
  @include breakpoint ('sm') {
    padding: 0 0.5rem;
    width: 33.333%;
  }
  @include productBreakpoint ('desktop-s') {
    padding: 0;
    width: 100%;
  }

  &__inner {
    background: $color-white;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24);
    border-radius: 2px;
    text-align: center;
    padding: 0.7em;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    margin: 0 2em;
    height: 100%;

    @include breakpoint ('sm') {
      margin: 0;
    }

    @include breakpoint ('lg') {
      padding: 1em;
    }

    &:hover {
      text-decoration: none;
    }
  }

  &__image {
    width: 100%;
    align-self: center;

    &__con {
      flex: 1 1 auto;
      max-width: 100px;
    }
  }

  &__container {
    flex: 1 1 50%;
    padding-left: 5px;
  }

  &__title {
    word-break: break-word;
  }

  &__loader {
    width: 30%;
  }

  &__price {
    text-align: left;
    font-size: 1rem;
    @extend %font-primary;
    color: $color-black;
    flex-grow: 1;
    align-items: flex-end;
    display: flex;

    .currency-code {
      display: inline;
      margin-left: 0.4em;
    }

    &__wrapper {
      display: flex;
      flex-wrap: wrap;
    }

    &__crossed {
      text-decoration: line-through;
      margin-right: 0.5em;
      flex-grow: unset;

      .currency-code {
        display: none;
      }
    }

    &__sale {
      color: $color-garmin-blue-40;
    }
  }

  .app__product__card__price {
    font-size: 1rem;
  }

  &:hover,
  &__title:hover,
  &__price:hover {
    text-decoration: none;
  }
}
</style>
